import { UwtSupplierType, UwtType } from 'modules/types/LeasingCalculatorCodes';
import { useCallback, useMemo, useState } from 'react';

export interface FormSharedProps<T> {
  defaultValues?: T;
  onChange: (userFormInfo: T) => void;
  onNextStep?: () => void;
  onPreviousStep?: () => void;
  onSubmit?: () => void;
}

export const useForm = (props?: FormSharedProps<any>) => {
  const { onChange, onNextStep } = props || {};
  const [validate, setValidate] = useState<boolean>(false);
  const [isFormValid, setFormValid] = useState<boolean>(false);

  const validateForm = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const formErrors = event.target.getElementsByClassName(
        'form-input-not-valid',
      );
      return formErrors?.length > 0;
    },
    [],
  );

  const updateFormData = useCallback(
    (
      propertyName: string,
      value: string | boolean | number | UwtType | undefined,
    ) => {
      onChange && onChange({ [propertyName]: value });
    },
    [onChange],
  );

  const updateSelectData = useCallback(
    (
      propertyName: string,
      value: string | boolean | number,
      types: UwtType[] | UwtSupplierType[],
    ) => {
      updateFormData(
        propertyName,
        types.find((type) => type.id === value),
      );
    },
    [updateFormData],
  );

  const handleOnSubmit = useCallback(
    async (event: any) => {
      event.preventDefault();
      setValidate(true);
      const validateErrors = validateForm(event);
      setFormValid(!validateErrors);

      if (validateErrors) {
        window.scrollTo(0, 0);
      } else if (onNextStep) {
        onNextStep();
      }
    },
    [onNextStep, validateForm],
  );

  const validateFlag = useMemo(() => validate, [validate]);

  return {
    validateForm,
    updateFormData,
    updateSelectData,
    handleOnSubmit,
    validateFlag,
    isFormValid,
  };
};
